import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {LinkSchema} from './link'

export const PersonalisationRuleAudienceConditionSchema = z.enum([
  'COPILOT_BUSINESS',
  'COPILOT_EDU',
  'COPILOT_ENTERPRISE',
  'COPILOT_FREE',
  'COPILOT_MAX',
  'COPILOT_PRO',
  'COPILOT_PRO_PLUS',
  'ENTERPRISE_ADMIN',
  'ENTERPRISE_MEMBER',
  'LOGGED_IN',
  'TEAM_ADMIN',
  'TEAM_MEMBER',
])

export const PersonalisationRuleSchema = buildEntrySchemaFor('personalisationRule', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      audienceCondition: PersonalisationRuleAudienceConditionSchema,
      link: LinkSchema,
    }),
  ),
})

export type PersonalisationRule = z.infer<typeof PersonalisationRuleSchema>
